import { render } from "./Filters.vue?vue&type=template&id=3fc0124c&scoped=true"
import script from "./Filters.vue?vue&type=script&lang=ts"
export * from "./Filters.vue?vue&type=script&lang=ts"

import "./Filters.vue?vue&type=style&index=0&id=3fc0124c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3fc0124c"

export default script